import { auth, err } from '../utils';
import axios, { AxiosResponse } from 'axios';
import { Coordinates } from '../utils/types/Coordinates';
import { PlaceSuggestion } from './googleMaps.types';

const URL = '/api/google-maps';

const getCoordinates = async (
  token: string,
  address: string,
): Promise<Coordinates | null> => {
  try {
    const res: AxiosResponse<{ coordinates: Coordinates }> = await axios.post(
      URL,
      { address },
      {
        headers: auth.bearerAuthHeader(token),
      },
    );

    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }

    const { coordinates } = res.data;
    return coordinates;
  } catch (e) {
    throw err.handleError(e, 'error getting coordinates');
  }
};

export const getAutoCompletePredictions = async (
  input: string,
  lang: string,
  sessionToken: string,
  token: string,
): Promise<PlaceSuggestion[]> => {
  try {
    const res: AxiosResponse<PlaceSuggestion[]> = await axios.post(
      `${URL}/autocomplete`,
      {
        input,
        lang,
        sessionToken,
      },
      {
        headers: auth.bearerAuthHeader(token),
      },
    );
    if (res.status < 200 || res.status >= 300) {
      throw new Error(`${res.status} error`);
    }
    return res.data;
  } catch (e) {
    throw err.handleError(e, 'error getting coordinates');
  }
};

export default {
  getCoordinates,
  getAutoCompletePredictions,
};
